import { withInstall } from '@bigin/utils'

import Card from './src/card.vue'

export const BCard = withInstall(Card)
export default BCard

export * from './src/card'
